<template>
  <div class="out_wrap">
    <div class="">
      <div class="left flex1">
        <el-form ref="queryControl" label-width="52px" :mode="queryControl">
          <div class="form-box">
            <el-form-item label="年份:" class="formItem">
              <el-date-picker v-model="queryControl.year" :editable="false" :clearable="false" value-format="yyyy" placeholder="请选择年份" type="year" @change="query" />
            </el-form-item>
            <div>
              <el-button type="primary" @click="query">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
              <el-button type="primary" @click="refresh">刷新</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div v-if="noticeShow" class="active_color mr15 mb10 pointer" @click="noticeShow = !noticeShow">查看指南</div>
    <div v-if="!noticeShow" class="useGuide mb22">
      <div>
        <span class="fs16 bold">使用指南</span>
        <a class="closeGuide active_color ml20" @click="noticeShow = !noticeShow">关闭指南</a>
      </div>
      <div style="line-height: 22px;margin-top: 16px;" class="c9">
        <div>1.如若贵司需要申请开票，请先在 <a class="active_color" @click="$router.push('/invoice/account_check_manage')">对账管理</a> 发起相应月份的结算单，结算单双发签署完成后，开票记录中相应月份会生成一条开票记录，平台会主动上传发票信息。</div>
        <div>2.贵司获取发票的方式有两种，可要求平台直接上传电子发票，贵司在系统主动下载即可，也可要求平台线下邮寄。</div>
        <div>3.如需线下邮寄请提前完成 <a class="active_color" @click="$router.push('/invoice/bill_info')">收票信息</a> 填写。</div>
      </div>
    </div>
    <div class="total_box mb20">
      <span class="mr20">累计任务总金额：<span class="active_color">￥{{ $formatCurrency(summary.all_total_price || '0.00') }}</span></span>
      <span>已开票总金额：<span class="active_color">￥{{ $formatCurrency(summary.all_overinvoice_price || '0.00') }}</span></span>
    </div>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- 月份 -->
      <template
        slot="month"
        slot-scope="{ row }"
      >
        <span>{{ row.month }}</span>
      </template>
      <!-- 可开票金额 -->
      <template
        slot="total_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.total_price) }}
      </template>
      <!-- 已开票金额 -->
      <template
        slot="overinvoice_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.overinvoice_price) }}
      </template>
      <!-- 开票中金额 -->
      <template
        slot="ininvoice_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.ininvoice_price) }}
      </template>
      <!-- 剩余开票金额 -->
      <template
        slot="surplus_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.surplus_price) }}
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="powerReg('072866b400538d17f4c0bc5e44062011')" class="active_color" @click="goDetail(row)">详情</a>
      </template>
    </zf-table>
  </div>
</template>

<script>
import column from './columns/billManage'
import ZfTable from '@/components/ZfTable/CoreTable'
import dayJs from 'dayjs'
import { summaryInvoice, updateInvoicesummary } from '@/api/invoice'
export default {
  name: 'BillManage',
  components: {
    ZfTable
  },
  data() {
    return {
      column,
      showMoreSearch: false,
      noticeShow: false,
      queryControl: {
        year: dayJs().format('YYYY')
      },
      expireTimeOption: {
        disabledDate(time) {
          // 获取当前月份
          const currentdate = dayJs().format('YYYYMM')
          const timedate = dayJs(time).format('YYYYMM')
          return currentdate <= timedate
        }
      },
      tableData: [],
      summary: {},
      pageControl: {
        total: '',
        pageSize: 10,
        page: 1
      },
      total: ''
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    resetForm() {
      this.queryControl = {
        year: dayJs().format('YYYY')
      }
      this.query()
    },
    async query() {
      const data = await summaryInvoice({
        year: this.queryControl.year
      })
      if (data.code === 200) {
        this.tableData = data.data.list
        if (data.data.length === 0) {
          this.summary.all_total_price = '0.00'
          this.summary.all_overinvoice_price = '0.00'
        } else {
          this.summary = data.data.total
        }
      }
    },
    goDetail(row) {
      this.$router.push({
        path: '/invoice/bill_detail',
        query: {
          month: row.month
        }
      })
    },
    async refresh() {
      await updateInvoicesummary()
      this.query()
      this.$message.success('刷新成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.billBox{
  .billItem{
    margin-bottom: 10px;
    .label{
      font-weight: 600;
      width: 80px;
      flex-shrink: 0;
      text-align: right;
    }
    .con{
      padding-left: 10px;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
